// extracted by mini-css-extract-plugin
export var section = "share-module--section--1eeif";
export var list = "share-module--list--1g4_S";
export var title = "share-module--title--4Eh3N";